import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup.object({
    dispatchMethod: yup.string().required(
      formatMessage({
        id: 'DISPATCH_METHOD_IS_REQUIRED',
        defaultMessage: 'Dispatch Method is required',
      }),
    ),
    serviceProviderType: yup.object().required(
      formatMessage({
        id: 'SERVICEPROVIDERTYPE_FIELD_IS_REQUIRED',
        defaultMessage: 'Service Provider Type is required',
      }),
    ),
    contractorComplianceStatus: yup.string(),
  });

export default validationSchema;
